<template>
  <div id="app" class="font-display">
    <div>
      <div class="overflow-hidden bg-cover bg-center md:h-screen" style="background-image: url(hero.jpeg)">
        <div class="w-full">
          <div class="container sticky top-0 px-8 py-4 flex items-center justify-between">
            <img src="/fullWhiteLogo.svg" class="h-12"></img>
            <div class="md:block hidden flex items-center">
              <a href="#about" class="font-semibold mx-4 text-white text-sm px-1 py-1 border-transparent hover:text-gray-200 hover:border-white border-b-2">About</a>
              <a href="#services" class="font-semibold mx-4 text-white text-sm px-1 py-1 border-transparent hover:text-gray-200 hover:border-white border-b-2">Services</a>
              <a href="#projects" class="font-semibold mx-4 text-white text-sm px-1 py-1 border-transparent hover:text-gray-200 hover:border-white border-b-2">Projects</a>
              <a href="mailto:steph@colorblind.design" class="font-semibold mx-4 text-white text-sm px-1 py-1 border-transparent hover:border-white hover:text-gray-200 border-b-2">Contact</a>
            </div>
          </div>
        </div>
        <div class="relative h-full flex md:items-center my-20 md:my-0 justify-center pb-12 sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
          <div class="mx-auto max-w-screen-xl px-4 sm:px-6">
            <div class="text-center">
              <h2 class="text-white text-4xl md:text-5xl tracking-tight leading-10 font-bold sm:leading-none">
                We <span class="text-white">design</span> and <span class="text-white">develop</span> all things digital.
              </h2>
              <p class="font-medium mt-3 max-w-md mx-auto text-base text-white sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                We will perfect your online presence through the thoughtful application of design and technology.
              </p>
              <div class="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
                <div class="rounded-md shadow">
                  <a href="mailto:steph@colorblind.design" class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium text-white bg-red hover:bg-light focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10">
                    Contact Us
                  </a>
                </div>
                <div class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
                  <a href="#services" class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium text-red bg-white hover:text-light focus:outline-none focus:shadow-outline-blue transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="latestProject" class="bg-gray-50">
      <div class="flex items-center justify-center relative bg-gray-50 container md:px-8 px-4" style="height: 70vh">
        <div class="md:absolute md:left-0 h-full md:w-1/2">
          <img class="md:block hidden w-full h-full object-cover" src="vivaLight.png" alt="Support team" />
          <img class="md:hidden w-full h-full object-cover" src="vivaMobile.png" alt="Support team" />
        </div>
        <div class="relative max-w-screen-xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <div class="md:ml-auto md:w-1/2 md:pl-10">
            <div class="text-xs md:text-base md:leading-6 uppercase tracking-wider text-indigo-500">
              Our Latest Project
            </div>
            <h2 class="mt-2 md:mt-4 text-lg md:text-3xl md:leading-9 font-semibold tracking-tight sm:text-4xl sm:leading-10">
              Building an inclusive financial system.
            </h2>
            <p class="mt-2 md:mt-4 md:text-lg md:leading-7 text-gray-600">
              VIVA finance is an employee wellness company that offers a platform for employers to provide their employees with instant loans with lower rates.
            </p>
            <div class="mt-4 md:mt-8">
              <div class="inline-flex rounded-md shadow-md">
                <a href="https://viva-finance.com/#/home" rel= "noreferrer" target="_blank" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium text-indigo-500 bg-white hover:text-indigo-400 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out">
                  View Project
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="bg-dark flex items-center justify-center" style="height: 50vh;">
        <div class="flex flex-col items-center justify-center max-w-screen-xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
          <h2 class="text-2xl md:text-3xl leading-9 font-medium tracking-tight text-white sm:text-4xl sm:leading-10">
            We create experiences that make people’s lives simple.
          </h2>
          <p class="md:w-2/3 text-lg my-8 text-gray-300">
            We design and develop highly responsive, interactive and robust applications that look good on every device.
          </p>
        </div>
      </div>
    </div>
    <div id="services" class="bg-gray-50">
      <div class="bg-gray-50 overflow-hidden py-20 container md:px-8 px-4">
        <div class="flex items-center">
          <p class="text-red font-medium text-lg mr-3">Services</p>
          <div class="bg-gray-200 w-full mr-4 h-px"></div>
        </div>
        <div class="relative mx-auto py-12">
          <div class="relative lg:grid lg:grid-cols-3 lg:col-gap-8">
            <div class="lg:col-span-1">
              <h3 class="text-2xl leading-9 font-semibold text-gray-900">
                We bring your ideas to life through beautiful design and flawless development.
              </h3>
            </div>
            <div class="mt-10 sm:grid sm:grid-cols-2 sm:col-gap-8 sm:row-gap-10 lg:col-span-2 lg:mt-0">
              <div>
                <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                  <i class="material-icons text-3xl">color_lens</i>
                </div>
                <div class="mt-5">
                  <h5 class="text-lg leading-6 font-medium text-gray-900">Branding</h5>
                  <p class="my-2 text-base leading-6 text-gray-600">
                    We will help you find your unique identity and translate it into a strong, inspirational brand. From logo design and color pallet to typogroghy and supporting elements, we make sure that your brand strikes a memorable chord with your audiences.
                  </p>
                  <a href="mailto:steph@colorblind.design" class="pb-1 border-b text-red border-red font-semibold hover:text-light hover:border-light">Request Service</a>
                </div>
              </div>
              <div class="mt-10 sm:mt-0">
                <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                  <i class="material-icons text-3xl">view_quilt</i>
                </div>
                <div class="mt-5">
                  <h5 class="text-lg leading-6 font-medium text-gray-900">UI/UX Design</h5>
                  <p class="my-2 text-base leading-6 text-gray-600">
                    We work closely with our clients to define, design, and develop transformative user experiences across all platforms. We create products and services that provide outstanding usability while fully embracing your brand's personality.
                  </p>
                  <a href="mailto:steph@colorblind.design" class="pb-1 border-b text-red border-red font-semibold hover:text-light hover:border-light">Request Service</a>
                </div>
              </div>
              <div class="mt-10 sm:mt-0">
                <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                  <i class="material-icons text-3xl">code</i>
                </div>
                <div class="mt-5">
                  <h5 class="text-lg leading-6 font-medium text-gray-900">Development</h5>
                  <p class="my-2 text-base leading-6 text-gray-600">
                    By using the latest technologies, we prioritize functionality, performance, and usability. We develop your app from the ground up, using industry standard development frameworks so it’s perfectly tailored to your needs and sustainable in the long term.
                  </p>
                  <a href="mailto:steph@colorblind.design" class="pb-1 border-b text-red border-red font-semibold hover:text-light hover:border-light">Request Service</a>
                </div>
              </div>
              <div class="mt-10 sm:mt-0">
                <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                  <i class="material-icons text-3xl">account_tree</i>
                </div>
                <div class="mt-5">
                  <h5 class="text-lg leading-6 font-medium text-gray-900">Marketing</h5>
                  <p class="my-2 text-base leading-6 text-gray-600">
                    From social media and search engine optimization to content creation, we will help your business engage your target audience. We will engage your audience by telling your story and sharing your mission in a way that keeps them coming back for more.
                  </p>
                  <a href="mailto:steph@colorblind.design" class="pb-1 border-b text-red border-red font-semibold hover:text-light hover:border-light">Request Service</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--div class="container px-8 py-20">
        <div class="flex items-center">
          <p class="text-red font-medium text-lg mr-3">Services</p>
          <div class="bg-gray-200 w-full mr-4 h-px"></div>
        </div>
        <div class="md:pt-20 pt-10 pb-12">
          <h3 class="w-3/4 mb-12 text-2xl md:text-3xl leading-9 font-medium tracking-tight text-gray-900 sm:leading-10">
            We bring your ideas to life through beautiful design and flawless development.
          </h3>
          <div class="max-w-xl mx-auto lg:max-w-screen-xl">
            <div class="lg:grid lg:grid-cols-3 lg:gap-8">
              <div class="mt-10 lg:mt-0">
                <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white shadow-md">
                  <i class="material-icons text-3xl">color_lens</i>
                </div>
                <div class="mt-5">
                  <h5 class="text-lg leading-6 font-medium">Branding</h5>
                  <p class="my-2 text-base leading-6 text-gray-600">
                    We will help you find your unique identity and translate it into a strong, inspirational brand. From logo design and color pallet to typogroghy and supporting elements, we make sure that your brand strikes a memorable chord with your audiences.
                  </p>
                  <a href="mailto:steph@colorblind.design" class="pb-1 border-b text-red border-red font-semibold hover:text-light hover:border-light">Request Service</a>
                </div>
              </div>
              <div class="mt-10 lg:mt-0">
                <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white shadow-md">
                  <i class="material-icons text-3xl">view_quilt</i>
                </div>
                <div class="mt-5">
                  <h5 class="text-lg leading-6 font-medium">UI/UX Design</h5>
                  <p class="my-2 text-base leading-6 text-gray-600">
                    We work closely with our clients to define, design, and develop transformative user experiences across all platforms. We create products and services that provide outstanding usability while fully embracing your brand's personality.
                  </p>
                  <a href="mailto:steph@colorblind.design" class="pb-1 border-b text-red border-red font-semibold hover:text-light hover:border-light">Request Service</a>
                </div>
              </div>
              <div class="mt-10 lg:mt-0">
                <div class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white shadow-md">
                  <i class="material-icons text-3xl">code</i>
                </div>
                <div class="mt-5">
                  <h5 class="text-lg leading-6 font-medium">Development</h5>
                  <p class="my-2 text-base leading-6 text-gray-600">
                    By using the latest technologies, we prioritize functionality, performance, and usability. We develop your app from the ground up, using industry standard development frameworks so it’s perfectly tailored to your needs and sustainable in the long term.
                  </p>
                  <a href="mailto:steph@colorblind.design" class="pb-1 border-b text-red border-red font-semibold hover:text-light hover:border-light">Request Service</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div-->
    </div>
    <div id="projects" class="bg-gray-50">
      <div class="container md:px-8 px-4 pb-20 z-10">
        <div class="flex items-center">
          <p class="text-red font-medium text-lg mr-3">Projects</p>
          <div class="bg-gray-200 w-full mr-4 h-px"></div>
        </div>
        <div class="relative">
          <div class="pt-20 grid gap-5 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
            <div class="flex flex-col shadow-md overflow-hidden">
              <div class="flex-shrink-0 w-full h-64 bg-cover" style="background-image: url(viva.jpg)">
                <div class="w-full h-full bg-gray-100 opacity-75 md:opacity-0 hover:opacity-75 flex items-center justify-center transition-opacity duration-1000 ease-out">
                  <div class="flex flex-col items-center justify-center">
                    <p class="font-semibold">VIVA Finance</p>
                    <p class="text-xs my-4 font-medium">UI/UX design - Frontend Development</p>
                    <a href="https://viva-finance.com/#/home" rel= "noreferrer" target="_blank" class="flex font-medium items-center justify-center text-sm cursor-default hover:font-semibold">View Project <i class="material-icons text-base">arrow_forward</i></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-col shadow-md overflow-hidden">
              <div class="flex-shrink-0 w-full h-64 bg-cover" style="background-image: url(waya.jpg)">
                <div class="w-full h-full bg-gray-100 opacity-75 md:opacity-0 hover:opacity-75 flex items-center justify-center transition-opacity duration-1000 ease-out">
                  <div class="flex flex-col items-center justify-center">
                    <p class="font-semibold">Waya.ai</p>
                    <p class="text-xs my-4 font-medium">UI/UX design - Frontend Development</p>
                    <a href="https://waya-ai.webflow.io/" rel= "noreferrer" target="_blank" class="flex font-medium items-center justify-center text-sm cursor-default hover:font-semibold">View Project <i class="material-icons text-base">arrow_forward</i></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-col shadow-md overflow-hidden">
              <div class="flex-shrink-0 w-full h-64 bg-cover" style="background-image: url(cheers.jpg)">
                <div class="w-full h-full bg-gray-100 opacity-75 md:opacity-0 hover:opacity-75 flex items-center justify-center transition-opacity duration-1000 ease-out">
                  <div class="flex flex-col items-center justify-center">
                    <p class="font-semibold">Cheers!</p>
                    <p class="text-xs my-4 font-medium">UI/UX design - Development</p>
                    <a href="https://cheers.colorblind.design/" rel= "noreferrer" target="_blank" class="flex font-medium items-center justify-center text-sm cursor-default hover:font-semibold">View Project <i class="material-icons text-base">arrow_forward</i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="blurb2" class="flex flex-col items-center justify-center bg-indigo-500 py-20 z-20">
      <p class="text-center text-3xl mb-8 font-medium text-white leading-tight tracking-wide w-5/6">Better design, better experiences.</p>
      <img src="verticalLogoFull.svg" class="h-40"/>
    </div>
    <div id="about" class="bg-gray-50">
      <div class="container md:px-8 px-4 py-20 z-20">
        <div class="flex items-center">
          <p class="text-red font-medium text-lg mr-3">About</p>
          <div class="bg-gray-200 w-full mr-4 h-px"></div>
        </div>
        <div class="z-20 pt-10">
          <p class="text-xl font-medium">We create beautiful websites and experiences.</p>
          <p class="my-4">Our unique design process is tailored to startups and established businesses who want to work like startups. We utilize the sprint model to create a custom, quality website in a fraction of the time. Colorblind Design Studio is based out of Dallas, Tx, however we work with clients all around the world.</p>
          <p class="text-xl font-medium mb-4">Looking for work?</p>
          <p>We are eagar to work with and discover some of the brightest minds in design or engineering. Even if you have your own business or freelance professional we are always open to collaborative projects, so get in touch!</p>
        </div>
        <div class="rounded-md shadow w-48 mt-8">
          <a href="mailto:steph@colorblind.design" class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base leading-6 font-medium text-white bg-red hover:bg-light focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out md:py-4 md:text-lg md:px-10">
            Contact Us
          </a>
        </div>
      </div>
    </div>
    <div id="map" class="bg-gray-100">
      <div class="">
        <iframe class="w-full" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10526.525378652346!2d-96.80830578465047!3d32.7876555631877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c19f77b45974b%3A0xb9ec9ba4f647678f!2sDallas%2C%20TX!5e0!3m2!1sen!2sus!4v1586742125443!5m2!1sen!2sus" width="600" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
      </div>
    </div>
    <div id="footer" class="bg-white">
      <div class="container px-8 pt-12">
        <div class="flex md:flex-row flex-col items-center pb-12 px-4 overflow-hidden sm:px-6 lg:px-8">
          <div class="md:w-1/2">
            <nav class="-my-2 flex md:justify-start justify-center flex-wrap">
              <div class="pr-5 py-2">
                <a href="#about" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                  About
                </a>
              </div>
              <div class="px-5 py-2">
                <a href="#services" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                  Services
                </a>
              </div>
              <div class="px-5 py-2">
                <a href="#projects" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                  Projects
                </a>
              </div>
              <div class="px-5 py-2">
                <a href="#home" class="text-base leading-6 text-gray-500 hover:text-gray-900">
                  Home
                </a>
              </div>
            </nav>
            <div class="mt-8 flex justify-center md:justify-start">
              <a href="https://www.youtube.com/channel/UCr8BLoBSZtmVr31UEfCiQfA" rel= "noreferrer" target="_blank" class="text-gray-400 hover:text-indigo-500">
                <span class="sr-only">Youtube</span>
                <i class="fab fa-youtube text-xl"></i>
              </a>
              <a href="https://www.instagram.com/steph_dietz/" rel= "noreferrer" target="_blank" class="ml-6 text-gray-400 hover:text-indigo-500">
                <span class="sr-only">Instagram</span>
                <i class="fab fa-instagram text-xl"></i>
              </a>
              <a href="https://twitter.com/SaaSyEth" rel= "noreferrer" target="_blank" class="ml-6 text-gray-400 hover:text-indigo-500">
                <span class="sr-only">Twitter</span>
                <i class="fab fa-twitter text-xl"></i>
              </a>
              <a href="https://github.com/StephDietz" rel= "noreferrer" target="_blank" class="ml-6 text-gray-400 hover:text-indigo-500">
                <span class="sr-only">GitHub</span>
                <i class="fab fa-github text-xl"></i>
              </a>
              <a href="https://www.linkedin.com/in/stephanie-dietz-47993bab/" rel= "noreferrer" target="_blank" class="ml-6 text-gray-400 hover:text-indigo-500">
                <span class="sr-only">Linkedin</span>
                <i class="fab fa-linkedin text-xl"></i>
              </a>
            </div>
            <div class="mt-8 flex flex-col">
              <p class="text-base leading-6 text-gray-400 md:text-left text-center">
                2020 Colorblind Design Studio. All rights reserved.
              </p>
              <div class="flex items-center mt-2 md:text-left text-center">
                <p class="text-gray-400 mr-2">Email:</p>
                <a href="mailto:steph@colorblind.design" class="hover:text-red underline text-gray-400">
                  steph@colorblind.design
                </a>
              </div>
            </div>
          </div>
          <!-- Begin Mailchimp Signup Form -->
            <div id="mc_embed_signup" class="md:w-1/2 w-full pt-2">
              <form action="https://design.us8.list-manage.com/subscribe/post?u=d50bb7739ba5988fe2183484f&amp;id=645eee5884" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                  <div id="mc_embed_signup_scroll" class="md:block flex flex-col items-center">
                    <h4 class="text-sm md:text-left text-center leading-5 font-semibold tracking-wider text-gray-400 uppercase md:ml-6 pb-6">
                      Subscribe to our mailing list
                    </h4>
                    <div class="mc-field-group flex">
                    	<input type="email" placeholder="Enter your email" value="" name="EMAIL" aria-label="Email address" class="required email md:ml-6" id="mce-EMAIL">
                    </div>
                    	<div id="mce-responses" class="clear">
                    		<div class="response" id="mce-error-response" style="display:none"></div>
                    		<div class="response" id="mce-success-response" style="display:none"></div>
                    	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                        <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_d50bb7739ba5988fe2183484f_645eee5884" tabindex="-1" value=""></div>
                        <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="w-full px-5 py-3 text-base leading-6 font-medium text-white bg-red focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"></div>
                  </div>
              </form>
            </div>

            <!--End mc_embed_signup-->
        </div>
      </div>
    </div>
  </div>
</template>



<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    // HelloWorld
  }
}
</script>
